<template>
  <div v-if="pageCount > 1" class="pager">
    <button :disabled="isFirstPage" class="pager__control-button" @click="$emit('prev')">
      <Icon name="ChevronOutlineLeft" />
    </button>
    <button v-for="item in visiblePages" :key="item" :class="`pager__item ${currentPage === item ? 'pager__item--active' : ''}`" :disabled="currentPage === item" @click="$emit('pageSelect', item)">
      {{ item }}
    </button>
    <button :disabled="isLastPage" class="pager__control-button" @click="$emit('next')">
      <Icon name="ChevronOutlineRight" />
    </button>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  currentPage: number,
  pageCount: number,
  isFirstPage: boolean,
  isLastPage: boolean,
}>()

const visiblePagesOffset = 0

const visiblePages = computed((): array => {
  const pages = [props.currentPage]
  for (let index = 1; index <= visiblePagesOffset; index++) {
    const negativeOffset = (0 - index) + props.currentPage
    const positiveOffset = index + props.currentPage
    if (shouldPageBeDisplayed(negativeOffset)) {
      pages.push(negativeOffset)
    }
    if (shouldPageBeDisplayed(positiveOffset)) {
      pages.push(positiveOffset)
    }
  }

  return pages.sort((a, b) => (a - b))
})

function shouldPageBeDisplayed (page: number): boolean {
  if (page > 0 && page <= props.pageCount) { return true }
  return false
}
</script>

<style lang="scss">
@use "~/assets/sass/tools";

.pager {
  display: flex;
  justify-content: center;
  gap: calc(var(--grid-gutter--xs) * 2);
  @include tools.to(tools.$breakpoint--desktop) {
    justify-content: center;
  }

  &__control-button,
  &__item {
    @include tools.button-borderless;

    &:hover {
      color: var(--color-text);
      background-color: var(--color-background);
    }
  }

  &__control-button { // stylelint-disable-line
    padding: 0;

    &[disabled] {
      opacity: 0.2;
    }
  }

  &__item { // stylelint-disable-line
    @include tools.typo-nav-item;
    -webkit-text-stroke: var(--border-width) var(--color-text);
    width: var(--button-pager-item-size);
    height: var(--button-pager-item-size);
    padding-bottom: 0.1em;
    color: var(--color-background);
    font-variant-numeric: tabular-nums;
    text-align: center;
  }

}
</style>
